<template>
  <div id="mapIndex">
    <div class="screen_container">
        <iframe style="" width="100%" height="100%" v-show="map3d" id='myFrame' name="myFrame" :src="path"></iframe>
        <div id="map_container" v-show="!map3d"></div>
    </div>

     <audio v-if="isMsg" muted  autoplay="autoplay" loop="loop">
        <source src="../../../static/voice/dududu.mp3" type="audio/ogg">
     </audio>

      <div class="title">
        <div class="title_bg">
          <div class="title_info">
            <div style="height: 50px;line-height: 49px;">智慧消防监测预警管理系统</div>
            <div class="image-border image-border1" style="width:10px;height:10px;"></div>
            <div class="image-border image-border2" style="width:10px;height:10px;"></div>
            <div class="image-border image-border3" style="width:10px;height:10px;"></div>
            <div class="image-border image-border4" style="width:10px;height:10px;"></div>  
          </div>
        </div>
        <span class="now_time">{{nowTime}}</span>
        <span class="now_time1">{{WeatherData.getDay}} {{WeatherData.weather}} {{WeatherData.temperature}}°C {{WeatherData.city}}</span>
      </div>

      <div v-if="userType !=3 && userType!=4">
          <div id="subtitle" class="subtitle" @click="subtitle"><span>{{getName.customerName}}</span></div>
      </div>
      <div v-else>
          <div id="subtitle" class="subtitle" @click="subtitle" v-if="map3d"><span>{{getName.customerName}}</span></div>
          <div id="subtitle" class="subtitle" style="cursor:auto;" v-else><span>{{getName.customerName}}</span></div>
      </div>

        <div class="subtitleleft"></div>
        <div class="subtitleright"></div>

        <img v-show="map3d" @click="gohome" class="gohome" src="../../assets/img/home.png" alt="">
        <div v-show="map3d">
            <img v-if="islock" @click="didi" class="horn" src="../../assets/img/play.png">
            <img v-else @click="didi" class="horn" src="../../assets/img/pause.png">
        </div>
      <!--中心容器-->
      <div class="center_container" :style="{width: containerWidth+'px'}">
        <div class="list_item" :style="{width:basicWidth+'px',marginLeft:basicLeft+'px'}">
          <!-- <p v-if="userType!=0">监测点总数</p>
          <p v-if="userType==0&&map3d">监测点总数</p>
          <p v-if="userType==0&&!map3d">校企单位总数</p>

          <p v-if="userType!=0">{{topTotalInfo.monitorCount}}</p>

          <p v-if="userType==0&&map3d">{{topTotalInfo.monitorCount}}</p>
          <p v-if="userType==0&&!map3d">{{topTotalInfo.customerCount}}</p> -->

           <template v-if="userType !=3 && userType!=4">
              <p v-if="userType!=0">监测点总数</p>
              <p v-if="userType==0&&map3d">监测点总数</p>
              <p v-if="userType==0&&!map3d">校企单位总数</p>
              
              <p v-if="userType!=0">{{topTotalInfo.totalCutomers}}</p>
              <p v-if="userType==0&&map3d">{{topTotalInfo.totalCutomers}}</p>
              <p v-if="userType==0&&!map3d">{{topTotalInfo.totalCutomers}}</p>
           </template>
           
            <template v-else>
              <p v-if="map3d">监测点总数</p>
              <p v-if="!map3d">校企单位总数</p>

              <p v-if="map3d">{{topTotalInfo.totalCutomers}}</p>
              <p v-if="!map3d">{{topTotalInfo.totalCutomers}}</p>
           </template>

          <div class="image-border image-border1"></div>
          <div class="image-border image-border2"></div>
          <div class="image-border image-border3"></div>
          <div class="image-border image-border4"></div>
        </div>
        <div class="list_item" :style="{width:basicWidth+'px',marginLeft:basicLeft+'px'}">
          <p>今日报警次数</p>
          <p>{{topTotalInfo.alarmsNumToday}}</p>
          <div class="image-border image-border1"></div>
          <div class="image-border image-border2"></div>
          <div class="image-border image-border3"></div>
          <div class="image-border image-border4"></div>
        </div>
        <div class="list_item" :style="{width:basicWidth+'px',marginLeft:basicLeft+'px'}">
          <p>昨日报警统计</p>
          <p>{{topTotalInfo.alarmsNumYesday}}</p>
          <div class="image-border image-border1"></div>
          <div class="image-border image-border2"></div>
          <div class="image-border image-border3"></div>
          <div class="image-border image-border4"></div>
        </div>
        <div class="list_item" :style="{width:basicWidth+'px',marginLeft:basicLeft+'px'}">
          <p>设备运行状态</p>
          <p>{{topTotalInfo.abnormalCount}}/{{topTotalInfo.normalCount}}</p>
          <div class="image-border image-border1"></div>
          <div class="image-border image-border2"></div>
          <div class="image-border image-border3"></div>
          <div class="image-border image-border4"></div>
        </div>
      </div>
      <!--标记信息-->
      <div v-if="userType !=3 && userType !=4" class="dot_tip" :style="{left: tipLeft+'px',top:tipTop+'px'}" v-show="isMouseIcon">
          <div class="image-border image-border1"></div>
          <div class="image-border image-border2"></div>
          <div class="image-border image-border3"></div>
          <div class="image-border image-border4"></div>
        <div class="name_type">
          <span>{{tipHeadInfo.schoolName}}</span>
          <span class="person_info">{{tipHeadInfo.userName}} {{tipHeadInfo.userPhone}}</span>
        </div>
        <div v-for="(item,index) in tipData" :key="index">
          <div class="normal_item" v-if="item.type==1 && item.typeNumber!='0/0'">
            <div class="info_item">
              <span class="icon_size">
                <i class="icon_type">
                    <img src="../../assets/img/icon_electric.png" alt="">
                </i>
                <span class="icon_name">电气</span>
              </span>
              <span class="item_name">{{item.typeNumber}}</span>
              <span class="info_type" v-if="item.typeName[0].deviceInfoSize.width<=140">
                <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===2" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
              </span>
              <span class="info_type" v-else>
                  <marquee>
                    <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===2" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
                  </marquee>
              </span>
            </div>
          </div>
          <!--水压-->
          <div class="normal_item" v-if="item.type==2&& item.typeNumber!='0/0'">
            <div class="info_item">
              <span class="icon_size">
                <i class="icon_type">
                    <img src="../../assets/img/icon_water.png" alt="">
                </i>
                <span class="icon_name">水压</span>
              </span>
              <span class="item_name">{{item.typeNumber}}</span>
              <span class="info_type" v-if="item.typeName[0].deviceInfoSize.width<=140">
                <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===2" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
              </span>
              <span class="info_type" v-else>
                  <marquee>
                    <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===2" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
                  </marquee>
              </span>
            </div>
          </div>
          <!--液位-->
          <div class="normal_item" v-if="item.type==3&& item.typeNumber!='0/0'">
            <div class="info_item">
              <span class="icon_size">
                <i class="icon_type">
                    <img src="../../assets/img/icon_level.png" alt="">
                </i>
                <span class="icon_name">液位</span>
              </span>
              <span class="item_name">{{item.typeNumber}}</span>
              <span class="info_type" v-if="item.typeName[0].deviceInfoSize.width<=140">
                <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===2" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
              </span>
              <span class="info_type" v-else>
                 <marquee>
                    <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===2" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
                  </marquee>
              </span>
            </div>
          </div>
          <!--可燃气-->
          <div class="normal_item" v-if="item.type==4&& item.typeNumber!='0/0'">
            <div class="info_item">
              <span class="icon_size">
                <i class="icon_type">
                    <img src="../../assets/img/icon_gas.png" alt="">
                </i>
                <span class="icon_name">可燃气</span>
              </span>

              <span class="item_name">{{item.typeNumber}}</span>
              <span class="info_type" v-if="item.typeName[0].deviceInfoSize.width<=140">
                <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===2" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
              </span>
              <span class="info_type" v-else>
                <marquee>
                    <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===2" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>

                  </marquee>
              </span>
            </div>
          </div>
          <!--烟感-->
          <div class="normal_item" v-if="item.type==5&& item.typeNumber!='0/0'">
            <div class="info_item">
              <span class="icon_size">
                <i class="icon_type">
                    <img src="../../assets/img/icon_smoke.png" alt="">
                </i>
                <span class="icon_name">烟感</span>
              </span>

              <span class="item_name">{{item.typeNumber}}</span>
              <span class="info_type" v-if="item.typeName[0].deviceInfoSize.width<=140">
                <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===2" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
              </span>
              <span class="info_type" v-else>
                <marquee>
                    <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===2" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>

                  </marquee>
              </span>
            </div>
          </div>
          <!--灭火器-->
          <div class="normal_item" v-if="item.type==6&& item.typeNumber!='0/0'">
            <div class="info_item">
              <span class="icon_size">
                <i class="icon_type">
                    <img src="../../assets/img/icon_bottol.png" alt="">
                </i>
                <span class="icon_name">灭火器</span>
              </span>
              <span class="item_name">{{item.typeNumber}}</span>
              <span class="info_type" v-if="item.typeName[0].deviceInfoSize.width<=140">
                <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===2" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
              </span>
              <span class="info_type" v-else>
                <marquee>
                    <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===2" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>

                  </marquee>
              </span>
            </div>
          </div>
          <!--水浸-->
          <div class="normal_item" v-if="item.type==7&& item.typeNumber!='0/0'">
            <div class="info_item">
              <span class="icon_size">
                <i class="icon_type">
                    <img src="../../assets/img/icon_ls.png" alt="">
                </i>
                <span class="icon_name">水浸</span>
              </span>
              <span class="item_name">{{item.typeNumber}}</span>
              <span class="info_type" v-if="item.typeName[0].deviceInfoSize.width<=140">
                <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===2" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
              </span>
              <span class="info_type" v-else>
                <marquee>
                    <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===2" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
                  </marquee>
              </span>
            </div>
          </div>
          <!--用传-->
          <div class="normal_item" v-if="item.type==8&& item.typeNumber!='0/0'">
            <div class="info_item">
              <span class="icon_size">
                <i class="icon_type">
                    <img src="../../assets/img/icon_using.png" alt="">
                </i>
                <span class="icon_name">用传</span>
              </span>
              <span class="item_name">{{item.typeNumber}}</span>
              <span class="info_type" v-if="item.typeName[0].deviceInfoSize.width<=140">
                <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===2" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
              </span>
              <span class="info_type" v-else>
                <marquee>
                    <span v-if="item.typeName[0].deviceType===0" style="color: #4caf50">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===1" style="color: #df504b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===2" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===3" style="color: #fe8463">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===4" style="color: #607d8b">{{item.typeName[0].deviceInfo}}</span>
                    <span v-else-if="item.typeName[0].deviceType===5" style="color: #676767">{{item.typeName[0].deviceInfo}}</span>
                  </marquee>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="dot_tip dot_tip2" :style="{left: tipLeft+'px',top:tipTop+'px'}" v-show="isMouseIcon">
          <div class="image-border image-border1"></div>
          <div class="image-border image-border2"></div>
          <div class="image-border image-border3"></div>
          <div class="image-border image-border4"></div>
        <div class="name_type">
          <span>{{tipHeadInfo.schoolName}}</span>
        </div>
        <div class="education">
          <p>安全主任：{{tipHeadInfo.userName}}</p>
          <p>电话：{{tipHeadInfo.userPhone}}</p>
          <p>地址：{{tipHeadInfo.detailAddress}}</p>
        </div>
      </div>
      <div class="left_content">
        <left ref="mapLeft"></left>
      </div>
      <div class="right_content">
        <right ref="mapRight"></right>
        <!-- <div class="right_info">
          <div v-if="topTotalInfo.alarmCount==0&&topTotalInfo.faultCount==0&&topTotalInfo.connectCount==0&&topTotalInfo.normalCount==0" class="No"  >
              <img style="margin: 0;" src="../../../static/img/Nodata.png">
              <span style="color:#fff;">暂无数据</span>
          </div>
          <div v-else>
            <div class="right_route">
                <span class="right_crumbs" style="background:#d7504b;"></span><span>告警：{{topTotalInfo.alarmCount}}个</span>
            </div>
            <div class="right_route">
                <span class="right_crumbs" style="background:#fe8463;"></span><span>故障：{{topTotalInfo.faultCount}}个</span>
            </div>
            <div class="right_route">
                <span class="right_crumbs" style="background:#607d8b;"></span><span>离线：{{topTotalInfo.connectCount}}个</span>
            </div>
            <div class="right_route">
                <span class="right_crumbs" style="background:#26c0c0;"></span><span>正常：{{topTotalInfo.normalCount}}个</span>
            </div>
          </div>
        </div> -->
      </div>
      
      
  </div>
</template>

<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";
  @import "@/assets/css/style.scss";
  @font-face {
    font-family: unidreamLED;
    src: url("../../assets/iconfont/UnidreamLed.ttf");
    /* IE9+  HTML节点的lang="en" 记得去掉，不然会谷歌浏览器会自动翻译导致字体不正确 */
  }
$text:#66b3ff;
$cyan:#00fcc9;
$border_color:#264480;
$grey:#8e8e8e;

.education{
  padding:15px 20px;
  &>p{
    margin-bottom: 10px;
  }
}
.gohome{
   width:24px;
    height:24px;
    position:absolute;
    left:20px;
    top:97px;
    z-index:10;
    cursor: pointer;
}
.horn{
   width:24px;
    height:24px;
    position:absolute;
    left:108px;
    top:97px;
    z-index:10;
    cursor: pointer;
}

.list_item{
  position: relative;
}

  .image-border {
	position: absolute;
	width: 20px;
	height: 20px;
}
		
.image-border1 {
	top: -1px;
	left: -1px;
	border-left: 1px solid #00b0ff;
	border-top: 1px solid #00b0ff;
}
		
.image-border2 {
	top: -1px;
	right:-1px;
	border-right: 1px solid #00b0ff;
	border-top:1px solid #00b0ff;
}
		
.image-border3 {
	bottom: -1px;
	left: -1px;
	border-bottom: 1px solid #00b0ff;
	border-left: 1px solid #00b0ff;
}
		
.image-border4 {
	bottom: -1px;
	right: -1px;
	border-right: 1px solid #00b0ff;
	border-bottom: 1px solid #00b0ff;
}

.subtitle{
    position: absolute;
    width: 62%;
    color: $cyan;
    font-size:$fontSizeFive;
    font-weight: normal;
    z-index: 9;
    top: 75px;
    left: 19%;
    text-align: center;
    height: 45px;
    line-height: 60px;
    background: url('../../assets/img/bugTop2.png') no-repeat;
    background-size: 100% 100%;
    cursor: pointer;

  }
  .subtitleleft{
    position: absolute;
    height:1px;
    width: 19%;
    background:rgba(0,175,254,0.9); 
    z-index: 9;
    top: 75px;
    left: 0;
  }
  .subtitleright{
    position: absolute;
    height:1px;
    width: 19%;
    background:rgba(0,175,254,0.9); 
    z-index: 9;
    top: 75px;
    right: 0;
  }
   .right_route{
    position: relative;
    height:36px;
  }
  .right_info{
    min-width: 130px;
    height:144px;
    border: 1px solid #264480;
    position: absolute;
    bottom: 8%;
    right: 400px;
    z-index: 1;
    .right_route>.right_crumbs{
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      margin: 10px 10px 10px 10px;

    }
    .right_route>span:nth-of-type(2){
      line-height: 36px;
      font-size: 13px !important;
      color: #e0e0e0;
      display: inline-block;
      position: absolute;
      left: 36px;
    }
  }
  .dot_tip{
    width: 380px;
    // height: 290px;
    position: fixed;
    border: 1px solid #264480;
    margin: 0 auto;
    z-index: 3;
    background:rgba(44,40,84,0.4);
    color: #fff;
    .name_type{
      font-size: 14px;
      font-weight: bold;
      color: #00b0ff;
      line-height: 35px;
      padding-left: 20px;
      background: rgba(44,40,84,.4);
      position: relative;
      .person_info{
        position: absolute;
        right: 20px;
        font-weight: normal;
        color: #26c0c0;
        font-size: 13px;
      }
    }
    .normal_item{
      height: 42.5px;
      .info_item{
        display: flex;
        height: 100%;
        align-items: center;
        padding: 0 20px;
        font-size: 13px;
        color: #fff;
        position: relative;
        .icon_size{
          display: inline-block;
          width: 100px;
          .icon_name{
            position: relative;
            top:-4px;
          }
          .icon_type{
            display: inline-block;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }
        .item_name{
          color: #26c0c0;
          display: inline-block;
          width: 80px;
        }
        .info_type{
          display: inline-block;
          width: 145px;
          position: relative;
          top:3px;
        }
      }
    }
  }
  .dot_tip2{
    height: 142px;
  }
  #mapIndex{
    width: 100%;
    height: 100%;
    position: relative;
    .screen_container{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top:0;
      .swiper-container{
        width: 100%;
        height: 100%;
        .el-carousel__arrow--right{
          right: 0;
        }
        .el-carousel__arrow--left{
          left: 0;
        }
      }
    }
    #map_container{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }
    #map_container1{
      width: 100%;
      height: 100%;
    }
    .title{
      font-size: 30px;
      font-weight: bold;
      position: relative;
      line-height: 50px;
      width: 28%;
      margin: 0 auto;
      padding-top: 30px;
      padding-bottom: 70px;
      z-index: 2;
      text-align: center;
      .title_bg{
        @include bgImg("../../../static/img/imgbg.png");
      }
      .title_info{
        display: inline-block;
        width: 100%;
        border: 1px solid #233D71;
        background-image:-webkit-linear-gradient(bottom,#0077ff,#59a6ff);
        -webkit-background-clip:text;
        -webkit-text-fill-color:transparent;
        position: relative;
      }
      .now_time{
        position: fixed;
        top: 23px;
        left: 20px;
        color:#26c0c0;
        font-size: 18px;
        font-weight: bold;
        line-height: 30px;
        padding: 0 6px;
      }

      .now_time1{
        position: fixed;
        top: 23px;
        right: 20px;
        color:#26c0c0;
        font-size: 18px;
        font-weight: bold;
        line-height: 30px;
        padding: 0 6px;
      }
    }
    .center_container{
      margin: 0 auto;
      position: relative;
      z-index: 2;
      display: flex;
      .list_item{
        padding-top: 12px;
        height: 100px;
        text-align: center;
        color:#28C2C1;
        background-color:rgba(44,40,84,.4);
        font-family: unidreamLED;
        border: 1px solid #264480;
        font-size:36px;
        :first-child{
          padding-bottom: 17px;
          font-size: 16px;
          color: #00b0ff;
        }
      }
    }
    .left_content{
      position: absolute;
      width: 360px;
      left: 20px;
      top:150px;
      z-index: 2;
    }
    .right_content{
      position: absolute;
      width: 360px;
      right: 20px;
      top:150px;
      z-index: 2;
    }
  }
</style>
<script>
  var map,copyMap;
  import left from '@/page/home/mapLeft'//左侧栏
  import right from '@/page/home/mapRight'//右侧栏
  import homeConstruction from '@/components/homeConstruction/index.vue'//建筑图组件
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import {ajaxFuncJson,SocketUrl} from '@/api/ajax';
  export  default {
    components:{
      left,
      right,
      swiper,
      swiperSlide,
      homeConstruction
    },
    data(){
      return{
        map3d:false,
        isMsg:false,
        islock:sessionStorage.getItem('islock'),
        userType:sessionStorage.getItem("userType"),
        path:'',
        showType:[{
          type:1,    //地图
        }],
        flag:false,
        tipData:[],
        mapSwiperOption:{
        },
        swiperOption1: {
          init: false,
          slidesPerView:1,
          spaceBetween: 10,
          autoplay:true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          disableOnInteraction: false,
        },
        swiperOption2: {
          init: false,
          slidesPerView:1,
          spaceBetween: 10,
          autoplay:true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          disableOnInteraction: false,
        },
        swiperOption3: {
          init: false,
          slidesPerView:1,
          spaceBetween: 10,
          autoplay:true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          disableOnInteraction: false,
        },
        swiperOption4: {
          init: false,
          slidesPerView:1,
          spaceBetween: 10,
          autoplay:true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          disableOnInteraction: false,
        },
        swiperOption5: {
          init: false,
          slidesPerView:1,
          spaceBetween: 10,
          autoplay:true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          disableOnInteraction: false,
        },
        swiperOption6: {
          init: false,
          slidesPerView:1,
          spaceBetween: 10,
          autoplay:true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          disableOnInteraction: false,
        },
        windowResize:null,
        basicWidth:0,
        basicLeft:0,
        containerWidth:0,
        infoWindow:null,   //定义信息窗口
        topTotalInfo:{},
        nowTime:'',
        clearTime:null,   //定时器
        schoolDeviceInfo:{     //学校设备信息

        },
        tipLeft:0,    //定位left值
        tipTop:0,    //定位top值
        isMouseIcon:false,   //是否移入icon点
        tipHeadInfo:{    //头部信息
          schoolName:'',
          userName: '',
          userPhone: '',
        },
        bodyWidth:0,
        bodyHeight:0,
        socketNotic:null,//websocket对象
        OneGo:'',//判断是否第一次  解决close报错
        getName:'',//名字
        WeatherData:{},//天气
        //  socketNoticClose :1,//我关闭的
          lockReconnect: false,//是否真正建立连接
          timeoutnum: null,//断开 重连倒计时
          timeoutnumSucc: null,//断开 重连倒计时
          timeoutnumSucc1: null,//断开 重连倒计时
      }
      
    },
    computed: {
      swiperLider0() {
        return this.$refs.myCenterSwiper1[0].swiper
      },
      swiperLider1() {
        return this.$refs.myCenterSwiper2[0].swiper
      },
      swiperLider2() {
        return this.$refs.myCenterSwiper3[0].swiper
      },
      swiperLider3() {
        return this.$refs.myCenterSwiper4[0].swiper
      },
      swiperLider4() {
        return this.$refs.myCenterSwiper5[0].swiper
      },
      swiperLider5() {
        return this.$refs.myCenterSwiper6[0].swiper
      },
    },
    created(){
        if(sessionStorage.getItem("userType") == 0 || sessionStorage.getItem("userType") == 3||sessionStorage.getItem("userType") == 4){
            this.getBigScreenData(sessionStorage.getItem("bureaucustomerId"));
            this.getCustomer(sessionStorage.getItem("bureaucustomerId"));//获取名字
        }else{
          this.getBigScreenData(sessionStorage.getItem("customerId"));
          this.getCustomer(sessionStorage.getItem("customerId"));//获取名字
        }
        this.getNowTime(); //获取当前时间
        this.getMapPosition(); //获取地图上面的点标记
        sessionStorage.setItem('buildId','');
    },
    mounted(){
      let that = this;
      that.websockeInit(sessionStorage.getItem("customerId1"));//连接websocket
      map = new AMap.Map('map_container',{
        // zoom: 10,  //设置地图显示的缩放级别
        // center: [116.397428, 39.90923],//设置地图中心点坐标
        // layers: [new AMap.TileLayer.Satellite()],  //设置图层,可设置成包含一个或多个图层的数组
        // mapStyle: 'amap://styles/darkblue',  //设置地图的显示样式 自定义地图样式amap://styles/地图样式id
        mapStyle: 'amap://styles/05caedbdec5c0f6edda8fa7cefced4e1',  //设置地图的显示样式 自定义地图样式amap://styles/地图样式id
        viewMode: '2D',  //设置地图模式
        lang:'zh_cn',  //设置地图语言类型
      });
      map.setZoom(12);

      AMap.plugin('AMap.Weather', function() {
        var weather = new AMap.Weather();
        
        //实例化城市查询类
        var citysearch = new AMap.CitySearch();
        //自动获取用户IP，返回当前城市
        citysearch.getLocalCity(function(status, result) {
            if (status === 'complete' && result.info === 'OK') {
                if (result && result.city && result.bounds) {
                    var cityinfo = result.city;
                    var citybounds = result.bounds;
                    //查询实时天气信息, 查询的城市到行政级别的城市，如朝阳区、杭州市
                    weather.getLive(cityinfo, function(err, data) {
                        if (!err) {
                          that.WeatherData = data;
                          that.WeatherData.getDay = that.getCurrentDate()
                        }
                    });
                }
            } 
        });

    });


      that.windowResize=function () {
        that.containerWidth=$('body').width()-360*2-20*2;
        that.basicWidth=($('body').width()-360*2-20*2)/29*6;
        that.basicLeft=($('body').width()-360*2-20*2)/29;
        that.bodyWidth=$('body').width();
        that.bodyHeight=$('body').height();
      };
      that.windowResize();
      window.addEventListener('resize',that.windowResize);
    },
    methods:{
      subtitle(){
         this.$router.push({path:'/content/MonitoringSupervise', query:{id:this.getName.id}});
      },
      didi(){
        this.islock = !this.islock;
        sessionStorage.setItem('islock',this.islock)
        if(sessionStorage.getItem('islock') == 'false'){
          this.isMsg = false;
        }
      },
      //返回地图页
      gohome(){
         this.map3d = false;
         sessionStorage.setItem('map3d',this.map3d);
         if(sessionStorage.getItem("userType") == 0){
           sessionStorage.setItem('customerId','')//清空集团id2020.9.30
            // 监管端
            // sessionStorage.setItem('customerId',sessionStorage.getItem("bureaucustomerId"))
            // sessionStorage.setItem('customerId1',sessionStorage.getItem("bureaucustomerId"))
            this.getCustomer(sessionStorage.getItem("bureaucustomerId"));//获取名字
            this.getBigScreenData(sessionStorage.getItem("bureaucustomerId"));
            this.$store.state.bigScreenBuildingId='';
            this.$refs.mapRight.getRight3D();

          }

          if(sessionStorage.getItem("userType") == 3||sessionStorage.getItem("userType") == 4){
             this.getCustomer(sessionStorage.getItem("bureaucustomerId"));//获取名字
            this.getBigScreenData(sessionStorage.getItem("bureaucustomerId"));
            this.$refs.mapLeft.getLeft3D();
            this.$refs.mapRight.getRight3D();
          }
      },
      // 获取今天周几
      getCurrentDate() {
        var myDate = new Date();
        var days = myDate.getDay();
        switch(days) {
              case 1:
                    days = '星期一';
                    break;
              case 2:
                    days = '星期二';
                    break;
              case 3:
                    days = '星期三';
                    break;
              case 4:
                    days = '星期四';
                    break;
              case 5:
                    days = '星期五';
                    break;
              case 6:
                    days = '星期六';
                    break;
              case 0:
                    days = '星期日';
                    break;
        }
        var str =  days;
        return str;
      },
      getCustomer(val){
        var params = {
          customerId:val,
        }
        ajaxFuncJson('/superviseIndex/getCustomer',params).then(res=>{
          this.getName = res.data.data;
        });
      },
      //获取当前的时间
      getNowTime(){
        this.clearTime=setTimeout( ()=> {
          let timeObj=new Date(),hour,minute,second;
          hour=timeObj.getHours();
          minute=timeObj.getMinutes();
          second=timeObj.getSeconds();
          if(timeObj.getHours()<10){
            hour='0'+timeObj.getHours();
          }
          if(timeObj.getMinutes()<10){
            minute='0'+timeObj.getMinutes();
          }
          if(timeObj.getSeconds()<10){
            second='0'+timeObj.getSeconds();
          }
          this.nowTime = timeObj.getFullYear()+'年'+(timeObj.getMonth()+1)+'月'+timeObj.getDate()+'日'+' '+hour+':'+minute+':'+second;
          this.getNowTime();
        },1000);
      },
      //获取大屏首页顶部统计数据
      getBigScreenData(data){
        if(sessionStorage.getItem("userType") == 3 || sessionStorage.getItem("userType") == 4){//教育局
            if(!this.map3d){
              sessionStorage.setItem('ISbureau',true);//监测进入状态
              ajaxFuncJson('/reginData/getRegionData',{}).then(res=>{
                if(res.data.status==200){
                  this.topTotalInfo=res.data.data[0];
                }else {
                  this.$message({
                    type:'error',
                    message: res.data.msg,
                  })
                }
              })
            }else{
              sessionStorage.setItem('ISbureau',false);//监测进入状态
              let params={
                id:data
              };
              ajaxFuncJson('/superviseIndex/getCustomerDataByCusId',params).then(res=>{
                if(res.data.status==200){
                  this.topTotalInfo=res.data.data[0];
                }else {
                  this.$message({
                    type:'error',
                    message: res.data.msg,
      
                  })
                }
              })
            }
        }else{
          sessionStorage.setItem('ISbureau',false);//监测进入状态
          sessionStorage.setItem('map3d',this.map3d);
          let params={
            id:data
          };
          ajaxFuncJson('/superviseIndex/getCustomerDataByCusId',params).then(res=>{
            if(res.data.status==200){
              this.topTotalInfo=res.data.data[0];
            }else {
              this.$message({
                type:'error',
                message: res.data.msg,
  
              })
            }
          })
        }
      },
      //获取地图上面的点标记经纬度
      getMapPosition(){
        if(sessionStorage.getItem("userType") == 3 || sessionStorage.getItem("userType") == 4){//教育局
            ajaxFuncJson('/reginData/getRegionCus',{}).then(res=>{
              if(res.data.status==200){
                  let markers=[];
                  console.log(map.markers)
                  res.data.data.forEach((item,index)=>{
                    if(item.pushStatus ==0){
                      var json={
                        icon:new AMap.Icon({
                          size: new AMap.Size(100, 100),
                          image: '../../../static/img/markersG.gif',
                          imageSize: new AMap.Size(100, 100)
                        }),
                        position:[item.longitude,item.latitude],
                        customerName:item.customerName,
                        id:item.id,
                        userName:item.userName,
                        userPhone:item.userPhone,
                      };
                    }else if(item.pushStatus==1){
                      var json={
                        icon:new AMap.Icon({
                          size: new AMap.Size(100, 100),
                          image: '../../../static/img/markersG2.gif',
                          imageSize: new AMap.Size(100, 100)
                        }),
                        position:[item.longitude,item.latitude],
                        customerName:item.customerName,
                        id:item.id,
                        userName:item.userName,
                        userPhone:item.userPhone,
                      };
                    }else{
                      var json={
                        icon:new AMap.Icon({
                          size: new AMap.Size(100, 100),
                          image: '../../../static/img/markersG1.gif',
                          imageSize: new AMap.Size(100, 100)
                        }),
                        position:[item.longitude,item.latitude],
                        customerName:item.customerName,
                        id:item.id,
                        userName:item.userName,
                        userPhone:item.userPhone,
                      };
                    }
                    if(item.longitude&&item.latitude){
                      markers.push(json);
                      this.$set(item,'type',2);
                      this.showType.push(item);
                    }
                  });
                  this.OneGo = 'two'
              var cc =  setInterval(()=>{
                  this.setMapIcon(markers);
                clearTimeout(cc);
              },500)
                  // this.websockeInit(sessionStorage.getItem("customerId1"));//连接websocket
              }else {
                this.$message({
                  type:'error',
                  message:res.data.msg,
                })
              }
            });
        }else{ //校企
            var params;
            if(sessionStorage.getItem("userType") == 0){
              params = {
                customerId:'',
              };
            }else{
              // 校企端
              params = {
                customerId:sessionStorage.getItem("customerId"),
              };
            }
    
            ajaxFuncJson('/superviseIndex/getCustomerList',params).then(res=>{
              if(res.data.status==200){
                  let markers=[];
                  res.data.data.forEach((item,index)=>{
                    if(item.pushStatus ==0){
                      var json={
                        icon:new AMap.Icon({
                          size: new AMap.Size(100, 100),
                          image: '../../../static/img/markersG.gif',
                          imageSize: new AMap.Size(100, 100)
                        }),
                        position:[item.longitude,item.latitude],
                        customerName:item.customerName,
                        id:item.id,
                        userName:item.userName,
                        userPhone:item.userPhone,
                      };
                    }else if(item.pushStatus==1){
                      var json={
                        icon:new AMap.Icon({
                          size: new AMap.Size(100, 100),
                          image: '../../../static/img/markersG2.gif',
                          imageSize: new AMap.Size(100, 100)
                        }),
                        position:[item.longitude,item.latitude],
                        customerName:item.customerName,
                        id:item.id,
                        userName:item.userName,
                        userPhone:item.userPhone,
                      };
                    }else{
                      var json={
                        icon:new AMap.Icon({
                          size: new AMap.Size(100, 100),
                          image: '../../../static/img/markersG1.gif',
                          imageSize: new AMap.Size(100, 100)
                        }),
                        position:[item.longitude,item.latitude],
                        customerName:item.customerName,
                        id:item.id,
                        userName:item.userName,
                        userPhone:item.userPhone,
                      };
                    }
                    // let json={
                    //   icon:new AMap.Icon({
                    //     size: new AMap.Size(100, 100),
                    //     image: '../../../static/img/markersG.gif',
                    //     imageSize: new AMap.Size(100, 100)
    
                    //   }),
                    //   position:[item.longitude,item.latitude],
                    //   customerName:item.customerName,
                    //   id:item.id,
                    //   userName:item.userName,
                    //   userPhone:item.userPhone,
                    // };
                    if(item.longitude&&item.latitude){
                      markers.push(json);
                      this.$set(item,'type',2);
                      this.showType.push(item);
                    }
                  });
                  this.OneGo = 'two'
              var cc =  setInterval(()=>{
                  this.setMapIcon(markers);
                  clearTimeout(cc);
              },500)
                  // this.websockeInit(sessionStorage.getItem("customerId1"));//连接websocket
    
              }else {
                this.$message({
                  type:'error',
                  message:res.data.msg,
                })
              }
            });
        }
      },


       // 心跳
      timeoutnumSuccF(){
          console.log('心跳')

          var that = this;
          that.timeoutnumSucc && clearTimeout(that.timeoutnumSucc);
          that.timeoutnumSucc1 && clearTimeout(that.timeoutnumSucc1);
          that.timeoutnumSucc = setTimeout(function () {
            if (that.socketNotic.readyState===1) {
              that.socketNotic.send("monitorReconnection");
            }
            that.timeoutnumSucc1 = setTimeout(function () {
              that.socketNotic.close();
            },10000);
          },1200000);
      },

       websockeInit(obj){
              var webSocketUrl = SocketUrl() 
              let customerId= sessionStorage.getItem('customerId1') 
              let token = sessionStorage.getItem('token');
              const wsuri = webSocketUrl + '/superviseIndex/totalOverview?customerId='+customerId+'&token='+token;//ws地址   
              if(token){
                this.socketNotic = new WebSocket(wsuri); 
                this.socketNotic.onopen = this.websocketonopen;
                this.socketNotic.onerror = this.websocketonerror;
                this.socketNotic.onmessage = this.websocketonmessage; 
                this.socketNotic.onclose = this.websocketclose;
              }
    　　},
    　　websocketonopen() {
        // console.log("连接成功");
        // this.socketNoticClose = 1;//连接成功他就等于1
         this.timeoutnumSuccF()
    　　},
        //错误
    　　websocketonerror(e) {
          // console.log("连接发生错误");
    　　},
        //数据接收 
    　　websocketonmessage(e){
          if(e.data =="connectSuccess"){
            this.timeoutnumSuccF();
            return;
          }else{
            var than = this;
      　　　const res = JSON.parse(e.data);
            // 获取子组件方法
            // if(sessionStorage.getItem("userType") == 0){
            //   if(than.map3d){
            //     than.getBigScreenData(this.$store.state.bigScreenBuildingId);
            //     than.$refs.mapLeft.watchWebsocket(this.$store.state.bigScreenBuildingId)
            //     than.$refs.mapRight.watchWebsocket(this.$store.state.bigScreenBuildingId)
            //   }
            // }else{
              let val = sessionStorage.getItem("customerId");
              if(e.data !=  "{}"){
                than.getMapPosition();//六期新增查询坐标点状态颜色
                than.getBigScreenData(sessionStorage.getItem("customerId1"));
                if(val){
                  than.$refs.mapLeft.watchWebsocket(val);
                  than.$refs.mapRight.watchWebsocket(val);
                }else{
                  than.$refs.mapLeft.watchWebsocket('');
                  than.$refs.mapRight.watchWebsocket('');
                }
              }
            // }
            if(sessionStorage.getItem('islock') == 'true'){
              than.isMsg = true;
            }
            setTimeout(function(){
              than.isMsg = false;
            },60000)
         }
    　　}, 
        //数据发送 
    　　websocketsend(agentData){
            //this.websock.send(agentData); 
    　　}, 
        //关闭
    　　websocketclose(e){ 
          console.log('连接关闭')
          if(e.code != 1000){
          var that = this;
          if(that.lockReconnect) {
              return;
          };
          that.lockReconnect = true;
          //没连接上会一直重连，设置延迟避免请求过多
          that.timeoutnum && clearTimeout(that.timeoutnum);
          that.timeoutnum = setTimeout(function () {
              //新连接
              that.websockeInit(sessionStorage.getItem("customerId1"));//连接websocket  
              that.lockReconnect = false;
          },10000);
          }
    　　},


      //设置点标记
      setMapIcon(markers){
        console.log('---------------------')
        map.clearMap();  // 清除地图覆盖物
        markers.forEach((marker,index)=>{
            var markerIcon=new AMap.Marker({
              map: map,
              icon: marker.icon,
              title:'',
              label:{
                offset: new AMap.Pixel(0, -10),  //设置文本标注偏移量
                content: "<div class='info'style='font-weight: bold;font-size: 16px;color: #26c0c0;' data-id="+marker.id+">"+marker.customerName+"</div>", //设置文本标注内容
                direction: 'top' //设置文本标注方位
              },
              position: [marker.position[0],marker.position[1]],
              offset: new AMap.Pixel(-60, -65),
            });
            markerIcon.id = marker.id
            markerIcon.content= '';
            markerIcon.on('click',this.markerGifClick);
            map.setFitView(); //存在标记点时，地图需将所有标记点展示到可见范围中；
            map.setZoom(14);

            // markerIcon.on('mouseover',this.markerClick);
            markerIcon.on('mouseover',this.getSchoolDeviceInfo);
            markerIcon.on('mouseout',this.closeWindowInfo);
            // markerIcon.emit('mouseover',{target:markerIcon});   //默认不显示

        });
        // map.setFitView();
        // marker.setMap(map);
      },
      markerGifClick(e){
          sessionStorage.setItem('customerId',e.target.id); //6期统一添加
          sessionStorage.setItem('customerId1',e.target.id);//6期统一添加
          let params = {
            id:e.target.id
          }

          if(sessionStorage.getItem("userType") == 0){
            this.$store.state.bigScreenBuildingId=e.target.id;
            this.getBigScreenData(e.target.id);
            this.getCustomer(e.target.id);
          }
          if(sessionStorage.getItem("userType") == 3||sessionStorage.getItem("userType") == 4){
            this.getCustomer(e.target.id);
          }
          ajaxFuncJson('/superviseIndex/selecThingJsById',params).then(res=>{
            if(res.data.status===200){
              this.path = res.data.data;
              if(this.path){
                this.map3d = true;
                sessionStorage.setItem('map3d',this.map3d);
                this.isMouseIcon=false;
                    if(sessionStorage.getItem("userType") == 3 ||sessionStorage.getItem("userType") == 4){
                      this.$store.state.bigScreenBuildingId=e.target.id;
                      this.getBigScreenData(e.target.id);
                      this.$refs.mapLeft.getLeft3D();
                      this.$refs.mapRight.getRight3D();
                    }
                    if(sessionStorage.getItem("userType") == 0){
                      this.$refs.mapRight.getRight3D();
                    }
              }else{
                this.$store.state.menuS = e.target.id;
                sessionStorage.setItem('menuS',e.target.id);
                this.$router.push({path:'/content/MonitoringSupervise', query:{id:e.target.id}});
              }
              }else {
                this.$message({
                  type:'error',
                  message:res.data.msg,
                })
              }
              
          })
      },
      //移入获取校企机构列表的信息
      getSchoolDeviceInfo(e){
        if(this.userType !=3 && this.userType !=4){
         this.tipData  = [];
        let id=e.target.getLabel().content.substring((e.target.getLabel().content.indexOf('data-id')+8),e.target.getLabel().content.indexOf('>'));
        let params={
          customerId: id,
        };
        this.showType.map((infoItem,infoIndex)=>{
          if(infoItem.type!==1){
            if(infoItem.id==id){
              this.tipHeadInfo={    //头部信息
                schoolName:infoItem.customerName,
                userName: infoItem.userName,
                userPhone: infoItem.userPhone,
              };
            }
          }
        });
          ajaxFuncJson('/superviseIndex/monitorGroupByType',params).then(res=>{
              if(res.data.status===200){
                this.schoolDeviceInfo=res.data.data;
                this.isMouseIcon=true;
                this.tipLeft=e.pixel.x;
                this.tipTop=e.pixel.y;
                if(e.pixel.y+290>this.bodyHeight){
                  this.tipTop=e.pixel.y-290;
                }
                if(e.pixel.x+360>this.bodyWidth){
                  this.tipLeft=e.pixel.x-360;
                }
                this.getMapTipData();
              }else {
                this.$message({
                  type:'error',
                  message:res.data.msg,
                })
              }
          })
        }else{
            let id=e.target.getLabel().content.substring((e.target.getLabel().content.indexOf('data-id')+8),e.target.getLabel().content.indexOf('>'));
            this.showType.map((infoItem,infoIndex)=>{
              if(infoItem.type!==1){
                if(infoItem.id==id){
                  this.tipHeadInfo={    //头部信息
                    schoolName:infoItem.customerName,
                    userName: infoItem.userName,
                    userPhone: infoItem.userPhone,
                    detailAddress:infoItem.detailAddress
                  };
                }
              }
                this.isMouseIcon=true;
                this.tipLeft=e.pixel.x;
                this.tipTop=e.pixel.y;
                if(e.pixel.y+290>this.bodyHeight){
                  this.tipTop=e.pixel.y-290;
                }
                if(e.pixel.x+360>this.bodyWidth){
                  this.tipLeft=e.pixel.x-360;
                }
            });
        }
      },

      //创建信息窗口
      markerClick(e) {
        this.infoWindow = new AMap.InfoWindow({offset: new AMap.Pixel(0, -30)});
        this.infoWindow.setContent(e.target.content);
        this.infoWindow.open(map, e.target.getPosition());
      },
      //移出关闭信息窗口
      closeWindowInfo(e){
        // e.target.setIcon('../../../static/img/markersG.gif');
        this.isMouseIcon=false;
      },
      //获取设备的数据进行处理
      dealInfoType(item,key){
        let json={
          deviceType:'',
          deviceInfo:item.replace(/;/g, '、'),
        };
        if(item.indexOf('正常')!==-1){   //0  正常  1告警  2预警  3故障  4离线
          json.deviceType=0;
        }else if(item.indexOf('告警')!==-1){
          json.deviceType=1;
        }else if(item.indexOf('预警')!==-1){
          json.deviceType=2;
        }else if(item.indexOf('故障')!==-1){
          json.deviceType=3;
        }else if(item.indexOf('离线')!==-1){
          json.deviceType=4;
        }else if(item.indexOf('暂无设备')!==-1){
          json.deviceType=5;
        }
        this.tipData[key].typeName.push(json);
      },
       textSize(fontSize,fontFamily,text){
        var span = document.createElement("span");
        var result = {};
        result.width = span.offsetWidth;
        result.height = span.offsetHeight;
        span.style.visibility = "hidden";
        span.style.fontSize = fontSize;
        span.style.fontFamily = fontFamily;
        span.style.display = "inline-block";
        document.body.appendChild(span);
        if(typeof span.textContent != "undefined"){
          span.textContent = text;
        }else{
          span.innerText = text;
        }
        result.width = parseFloat(window.getComputedStyle(span).width) - result.width;
        result.height = parseFloat(window.getComputedStyle(span).height) - result.height;
        return result;
      },

      getMapTipData(){
        let _this=this;
        this.tipData=[];
        // this.tipData=[{
        //   type:'1',
        //   typeName:[],   //alarmNames
        //   typeNumber:this.schoolDeviceInfo.electric.alarmRatio,
        // },{
        //   type:'2',
        //   typeName:[],
        //   typeNumber:this.schoolDeviceInfo.water.alarmRatio,
        // },{
        //   type:'3',
        //   typeName:[],
        //   typeNumber:this.schoolDeviceInfo.liquid.alarmRatio,
        // },{
        //   type:'4',
        //   typeName:[],
        //   typeNumber:this.schoolDeviceInfo.gas.alarmRatio,
        // },{
        //   type:'5',
        //   typeName:[],
        //   typeNumber:this.schoolDeviceInfo.somke.alarmRatio,
        // },{
        //   type:'6',
        //   typeName:[],
        //   typeNumber:this.schoolDeviceInfo.fire.alarmRatio,
        // },{
        //   type:'7',
        //   typeName:[],
        //   typeNumber:this.schoolDeviceInfo.ls.alarmRatio,
        // }];
        if(this.schoolDeviceInfo.length > 0){
          this.schoolDeviceInfo.forEach((a,b)=>{
               let jsonA = {
                    type:a.type,
                    typeName:[],   //alarmNames
                    typeNumber:a.alarmRatio,
               }
              this.tipData.push(jsonA);
              this.dealInfoType(a.alarmNames,b);
          })
        }
        // if(this.schoolDeviceInfo.electric){
        //   this.tipData.push({
        //     type:'1',
        //     typeName:[],   //alarmNames
        //     typeNumber:this.schoolDeviceInfo.electric.alarmRatio,
        //   })
        //   this.dealInfoType(this.schoolDeviceInfo.electric.alarmNames,0);
        // }
        // if(this.schoolDeviceInfo.water){
        //   this.tipData.push({
        //   type:'2',
        //   typeName:[],
        //   typeNumber:this.schoolDeviceInfo.water.alarmRatio,
        // })
        //   this.dealInfoType(this.schoolDeviceInfo.water.alarmNames,1);
        // }
        // if(this.schoolDeviceInfo.liquid){
        //   this.tipData.push({
        //   type:'3',
        //   typeName:[],
        //   typeNumber:this.schoolDeviceInfo.liquid.alarmRatio,
        // })
        //   this.dealInfoType(this.schoolDeviceInfo.liquid.alarmNames,2);
        // }
        // if(this.schoolDeviceInfo.gas){
        //   this.tipData.push({
        //   type:'4',
        //   typeName:[],
        //   typeNumber:this.schoolDeviceInfo.gas.alarmRatio,
        // })
        //   this.dealInfoType(this.schoolDeviceInfo.gas.alarmNames,3);
        // }
        // if(this.schoolDeviceInfo.somke){
        //   this.tipData.push({
        //   type:'5',
        //   typeName:[],
        //   typeNumber:this.schoolDeviceInfo.somke.alarmRatio,
        // })
        //   this.dealInfoType(this.schoolDeviceInfo.somke.alarmNames,4);
        // }
        // if(this.schoolDeviceInfo.fire){
        //   this.tipData.push({
        //   type:'6',
        //   typeName:[],
        //   typeNumber:this.schoolDeviceInfo.fire.alarmRatio,
        // })
        //   this.dealInfoType(this.schoolDeviceInfo.fire.alarmNames,5);
        // }
        // if(this.schoolDeviceInfo.ls){
        //   this.tipData.push({
        //   type:'7',
        //   typeName:[],
        //   typeNumber:this.schoolDeviceInfo.ls.alarmRatio,
        // })
        //   this.dealInfoType(this.schoolDeviceInfo.ls.alarmNames,6);
        // }
        this.tipData.forEach((item,index)=>{  
            item.typeName[0].deviceInfoSize =  this.textSize("13px","Arial",item.typeName[0].deviceInfo);
        })
      },
    },
    destroyed(){
      let _this=this;
      window.removeEventListener("resize",_this.windowResize);
      clearTimeout(this.clearTime);
      //               var webSocketUrl = SocketUrl() 
      //         let customerId= sessionStorage.getItem('customerId1') 
      //         let token = sessionStorage.getItem('token');
      //         const wsuri = webSocketUrl + '/superviseIndex/totalOverview?customerId='+customerId+'&token='+token;//ws地址 
      // if("WebSocket" in window) {
      //   let ws = new WebSocket(wsuri);
      //   ws.close();
      // }
      console.log(_this.socketNotic+'已经关闭')
      _this.socketNotic.close();
    },
  }
</script>



// WEBPACK FOOTER //
// src/page/Home/mapIndex.vue